import React, { useEffect } from 'react'
import { useParams, Link } from 'react-router-dom'
import { fetchingDetail } from '../store'
import { useDispatch, useSelector } from 'react-redux'
import LoadingComponent from './Loading'
import Error from './Error'

export default function NewsSummary (props) {
  const { id } = useParams()
  const { newsDetail, loading1, error } = useSelector(state => state)
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(fetchingDetail(id))
  }, [id])

  if (loading1) return <LoadingComponent />
  if (error) return <Error />
  return (
    <React.Fragment>
      <div className="shadow shadow-lg rounded bg-gray py-3 px-1">
        <div className="row no-gutters  justify-content-center">
          <div className="h5 font-weight-bolder">{newsDetail.title} </div>
        </div>
        <div className="row p-2 no-gutters">
          <img src={newsDetail.imageUrl} alt="" className="col-5 p-2 img-thumbnail shadow"/>
          <div className="col-7 p-2 px-4">
            <p className="text-muted small">{newsDetail.newsSite} - {new Date(newsDetail.publishedAt).toUTCString()} </p>
            <p className="text">{newsDetail.summary} <a target="#" href={newsDetail.url}>view more</a></p>
            <Link to={`/`}><button className=" btn btn-info btn-sm">Back to Home</button></Link>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}